import * as yup from 'yup';
import { PropertyUtils } from '../utils';

export function createSchema<T>(fieldsSchema: [(item: T) => any | string, yup.AnySchema][]) {

    let obj: any = { }
    fieldsSchema.forEach(x => {
        let name = typeof x[0] === 'string' ? x[0] : PropertyUtils.propertyName<T, keyof T>(x[0]);
        obj[name] = x[1]
    })

    return yup.object().shape(obj);
}